/* eslint-disable @emotion/syntax-preference */
import React, { memo } from 'react'

import { keyframes } from '@emotion/react'
import styled from '@emotion/styled'

import { Box } from '../uiKit/components/Box'

const bounce = keyframes`
  0%, 80%, 100% {
    transform: scale(0)
  }
  40% {
    transform: scale(1.0)
  }
`

const spinkitSize = 40
const delayRange = 0.32

const StyledContainer = styled(Box)`
  position: absolute;
  top: calc(50% - 10px);
  left: calc(50% - 40px);
  width: ${spinkitSize * 2}px;
  text-align: center;
`

const StyledChild = styled(Box)`
  width: ${spinkitSize / 2}px;
  height: ${spinkitSize / 2}px;
  display: inline-block;
  animation: ${bounce} 1.4s ease-in-out 0s infinite both;
  border-radius: 100%;
  background-color: ${({ theme }) => theme.ui.colors['blue.100']};
`

const StyledChild1 = styled(StyledChild)({
  animationDelay: `-${delayRange}s`,
})

const StyledChild2 = styled(StyledChild)({
  animationDelay: `-${delayRange / 2}s`,
})

export const Loader = memo(() => (
  <StyledContainer>
    <StyledChild1 />
    <StyledChild2 />
    <StyledChild />
  </StyledContainer>
))
